/* 🤖 this file was generated by svg-to-ts */
export const DfIconThumbsDown16: {
  name: 'thumbs-down-16';
  data: string;
} = {
  name: 'thumbs-down-16',
  data: `<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M12 2.444v7.111a2 2 0 0 1-.318 1.082l-3.154 4.905a1 1 0 0 1-1.362.313l-.57-.348a1 1 0 0 1-.46-1.05l.659-3.399a1 1 0 0 0-.866-1.183l-4.444-.52A1.73 1.73 0 0 1 0 7.643V6.46a2 2 0 0 1 .098-.619l1.452-4.46A2 2 0 0 1 3.452 0h5.209a2 2 0 0 1 .63.102l1.338.444A2 2 0 0 1 12 2.444zM14 11a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1z" fill-rule="evenodd"/></svg>`
};
